import React from 'react'
import { Card, CardBody, Col, Input } from 'reactstrap'
import CardHeaderSpan from '../../../../../Utils/CommonComponents/CardHeaderSpan'
import { SubscriberTitle } from '../../../../../Utils/Constants'
import { Btn, P } from '../../../../../AbstractElements'

export default function Subscriber() {
    return (
        <Col sm={12}>
            <Card>
                <CardHeaderSpan headingClassName='pb-0 border-0' smallHeading={SubscriberTitle} />
                <CardBody>
                    <P className="mb-2">{'To get more detail for new types of blogs.'}</P>
                    <Input type="email" placeholder="Enter your email" />
                    <Btn color='primary' className="w-100 mt-3">{'Get Started'}</Btn>
                </CardBody>
            </Card>
        </Col>
    )
}